import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let jobsMountPromise = null;

export function initJobsViewFragment({ onMounted } = {}) {
  registerViewMount('admin-jobs', () => mountJobsView(onMounted));
}

async function mountJobsView(onMounted) {
  if (document.getElementById('view-admin-jobs')) return;
  if (jobsMountPromise) return jobsMountPromise;

  jobsMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/jobs.html', 'Unable to load jobs admin view');
    onMounted?.();
  })();

  try {
    await jobsMountPromise;
  } catch (error) {
    jobsMountPromise = null;
    throw error;
  }
}
